import {
  API_ENDPOINT,
  type ClientApiV4AuthSignupCreateVariables,
  useClientApiV3AuthSignupCreateMutation,
  useClientApiV4AuthSignupCreateMutation,
} from '../../resources/@types/accountSchema';
import { useAgreedOver14Feature } from '../lib/hackle/feature';

interface UseClientV4AuthSignupMutation {
  options?: Parameters<typeof useClientApiV4AuthSignupCreateMutation>[0]['options'];
}

/**
 * 만14세 약관(CHAL-1250) 기능플래그에 따라 v4 / v3 중 하나로 가입 요청한다.
 * v3 에는 agreedOver14 필드가 없어 호출부가 넘긴 값을 떼고 보낸다.
 * 두 API 의 응답 타입은 동일해 options 를 그대로 공유한다.
 */
export function useAuthSignupCreateMutation({ options }: UseClientV4AuthSignupMutation) {
  const { isAgreedOver14FeatureOn } = useAgreedOver14Feature();

  const v4 = useClientApiV4AuthSignupCreateMutation({
    url: API_ENDPOINT.CLIENT_V4_AUTH_SIGNUP,
    options,
  });
  const v3 = useClientApiV3AuthSignupCreateMutation({
    url: API_ENDPOINT.CLIENT_V3_AUTH_SIGNUP,
    // UseMutationOptions 가 변수 타입에 반변이라 v4 용 options 를 그대로 넘길 수 없다.
    // 응답 타입은 양쪽 다 SignupEmailAndPasswordResponseV3 로 같아 단언이 안전하다.
    options: options as Parameters<typeof useClientApiV3AuthSignupCreateMutation>[0]['options'],
  });

  const mutateWithoutAgreedOver14 = ({
    agreedOver14: _agreedOver14,
    ...variables
  }: ClientApiV4AuthSignupCreateVariables) => {
    v3.mutate(variables);
  };

  if (isAgreedOver14FeatureOn) {
    return v4;
  }

  return { ...v3, mutate: mutateWithoutAgreedOver14 };
}
